import { render, staticRenderFns } from "./Type1View.vue?vue&type=template&id=4285996d&"
import script from "./Type1View.vue?vue&type=script&lang=js&"
export * from "./Type1View.vue?vue&type=script&lang=js&"
import style0 from "./Type1View.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports